import { 
  collection, 
  addDoc, 
  query, 
  where, 
  getDocs,
  updateDoc,
  doc,
  orderBy,
  limit 
} from 'firebase/firestore';
import { db } from './firebase';

class NotificationService {
  // Bildirim oluştur
  async createNotification(data) {
    try {
      const notification = {
        userId: data.userId,
        type: data.type, // 'booking_request', 'booking_confirmed', 'booking_cancelled', 'message'
        title: data.title,
        message: data.message,
        read: false,
        relatedId: data.relatedId || null, // booking ID, message ID, etc.
        createdAt: new Date().toISOString()
      };

      const docRef = await addDoc(collection(db, 'notifications'), notification);
      console.log('✅ Notification created:', docRef.id);
      return docRef.id;
    } catch (error) {
      console.error('Create notification error:', error);
      throw error;
    }
  }

  // Kullanıcının bildirimlerini getir
  async getUserNotifications(userId, limitCount = 20) {
    try {
      const q = query(
        collection(db, 'notifications'),
        where('userId', '==', userId),
        orderBy('createdAt', 'desc'),
        limit(limitCount)
      );

      const snapshot = await getDocs(q);
      const notifications = [];
      
      snapshot.forEach((doc) => {
        notifications.push({ id: doc.id, ...doc.data() });
      });

      return notifications;
    } catch (error) {
      console.error('Get notifications error:', error);
      throw error;
    }
  }

  // Okunmamış bildirim sayısı
  async getUnreadCount(userId) {
    try {
      const q = query(
        collection(db, 'notifications'),
        where('userId', '==', userId),
        where('read', '==', false)
      );

      const snapshot = await getDocs(q);
      return snapshot.size;
    } catch (error) {
      console.error('Get unread count error:', error);
      return 0;
    }
  }

  // Bildirimi okundu olarak işaretle
  async markAsRead(notificationId) {
    try {
      await updateDoc(doc(db, 'notifications', notificationId), {
        read: true,
        readAt: new Date().toISOString()
      });
    } catch (error) {
      console.error('Mark as read error:', error);
      throw error;
    }
  }

  // Tüm bildirimleri okundu olarak işaretle
  async markAllAsRead(userId) {
    try {
      const q = query(
        collection(db, 'notifications'),
        where('userId', '==', userId),
        where('read', '==', false)
      );

      const snapshot = await getDocs(q);
      
      const updatePromises = [];
      snapshot.forEach((docSnap) => {
        updatePromises.push(
          updateDoc(doc(db, 'notifications', docSnap.id), {
            read: true,
            readAt: new Date().toISOString()
          })
        );
      });

      await Promise.all(updatePromises);
      console.log(`✅ Marked ${updatePromises.length} notifications as read`);
    } catch (error) {
      console.error('Mark all as read error:', error);
      throw error;
    }
  }

  // Rezervasyon için bildirimler oluştur
  async notifyBookingRequest(teacherId, booking) {
    return this.createNotification({
      userId: teacherId,
      type: 'booking_request',
      title: '🎓 New Booking Request',
      message: `${booking.studentName} wants to book a ${booking.lessonType} lesson on ${new Date(booking.dateTime).toLocaleDateString()}`,
      relatedId: booking.id
    });
  }

  async notifyBookingConfirmed(studentId, booking) {
    return this.createNotification({
      userId: studentId,
      type: 'booking_confirmed',
      title: '✅ Lesson Confirmed',
      message: `${booking.teacherName} confirmed your lesson on ${new Date(booking.dateTime).toLocaleDateString()}`,
      relatedId: booking.id
    });
  }

  async notifyBookingCancelled(userId, booking, cancelledBy) {
    return this.createNotification({
      userId: userId,
      type: 'booking_cancelled',
      title: '❌ Lesson Cancelled',
      message: `Your lesson on ${new Date(booking.dateTime).toLocaleDateString()} has been cancelled${cancelledBy ? ` by ${cancelledBy}` : ''}`,
      relatedId: booking.id
    });
  }
}

export default new NotificationService();